const auxQueryParamsRotaMailing = values => {
    try {
        let query = '';

        if(values.valorCpf) {query+= `cpf=${values.valorCpf}&`;}

        if(values.nome) {query+= `nome=${values.nome}&`;}

        if(values.inscricao) {query+= `inscricao=${values.inscricao}`;}

        return query;
    } catch (error) {
        console.log(error);
    }
};

export default auxQueryParamsRotaMailing;
